export default __webpack_public_path__ + "static/media/stanne.9a5ea929.jpg";